/* eslint-disable import/no-anonymous-default-export */
import { navigationItemType, showForDeviceType, showForUserType, showForSiteType , showForProduct, showHasNotProduct} from '../../hooks';
import { alertType } from '../../components/Alert/alertType';

export default [
    {
        label: "Word Search",
        path: "/en/",
        show_for_users: [showForUserType.has_permissions],
        show_for_product:[showForProduct.RavMilim],
        type: navigationItemType.link,
    },     
    {
        label: "Word Search",
        show_for_users: [showForUserType.has_not_permissions],
        type: navigationItemType.alert,
        alert_data: {
            type: alertType.sign_up,
        },
    },    
    {
        label: "Word Search",
        show_for_users: [showForUserType.has_permissions],
        show_has_not_product:[showHasNotProduct.RavMilim],
        type: navigationItemType.alert,
        alert_data: {
            type: alertType.temp_alert,
        },
    },      
    {
        label: "Nakdan Morfix",
        path: "/en/nakdan",
        show_for_users: [showForUserType.has_permissions],
        show_for_product:[showForProduct.Nakdan],
        type: navigationItemType.link,
    },  
    {
        label: "Nakdan Morfix",
        show_for_users: [showForUserType.has_not_permissions],
        type: navigationItemType.alert,
        alert_data: {
            type: alertType.sign_up,
            path: "/nakdan",
        },
    },
    {
        label: "Nakdan Morfix",
        show_for_users: [showForUserType.has_permissions],
        show_has_not_product:[showHasNotProduct.Nakdan],
        type: navigationItemType.alert,
        alert_data: {
            type: alertType.temp_alert,
        },
    }, 
    
    {
        label: "Personal Zone",
        path: "/en/user",
        show_for_users: [showForUserType.external, showForUserType.privet],
        type: navigationItemType.link,
    },  
    {
        label: "Personal Zone",
        show_for_users: [showForUserType.guest],
        show_for_sites: [showForSiteType.main],
        type: navigationItemType.alert,
        alert_data: {
            type: alertType.sign_up,
        },
    },  
    {
        label:  "Terms of Use",
        path: "/en/license",
        type: navigationItemType.link,
    }, 
    {
        label:  "Contact us",
        path: "/en/contact_us",
        type: navigationItemType.link,
    }, 
    {
        label: "Morfix",
        path: "https://www.morfix.co.il/en/",
        type: navigationItemType.link,
    }, 
    {
        label: "Crosswords Puzzle",
        path: "/en/crossword",
        show_for_users: [showForUserType.has_permissions],
        show_for_product:[showForProduct.RavMilim],
        type: navigationItemType.link,
    }, 
    {
        label: "Crosswords Puzzle",
        show_for_users: [showForUserType.has_not_permissions],
        type: navigationItemType.alert,
        alert_data: {
            type: alertType.sign_up,
            path: "/crossword",
        },
    },
    {
        label: "Crosswords Puzzle",
        show_for_users: [showForUserType.has_permissions],
        show_has_not_product:[showHasNotProduct.RavMilim],
        type: navigationItemType.alert,
        alert_data: {
            type: alertType.sign_up,
        },
    }, 
    {
        label:  "Numbers to Text",
        path: "/en/numbers",
        type: navigationItemType.link,
    },   
    {
        label: "About",
        path: "/en/about",
        type: navigationItemType.link,
    },   
    {
        label:  "Editing Guidelines",
        path: "/en/editors_note",
        type: navigationItemType.link,
    },   
    {
        label:  "Blog",
        path: "https://blog.ravmilim.co.il/",
        type: navigationItemType.link,
    },    
    {
        label:  "Help",
        path: "https://blog.ravmilim.co.il/rav-milim-user-guide/",
        type: navigationItemType.link,
        target: "_blank",
    },    
    {
        label: "Cancel Subscription",
        path: "/en/contact_us",
        type: navigationItemType.link,
        show_for_devises: [showForDeviceType.pc],
    },
    {
        label: "Cancellation Policy",
        path: "/en/cancellation",
        type: navigationItemType.link,
        show_for_devises: [showForDeviceType.pc],
    },
    {
        label: "Privacy Policy",
        path: "/en/privacy_policy",
        type: navigationItemType.link,
        show_for_devises: [showForDeviceType.pc],
    }
];